import { GetStaticPaths, GetStaticProps } from "next";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";

const REDIRECT_LINK = "https://stader.gitbook.io/stader";

export const REDIRECT_MAP: Record<string, string> = {
  "": REDIRECT_LINK,
  "category/ethereum": `${REDIRECT_LINK}/ethereum`,
  "category/bnb-chain": `${REDIRECT_LINK}/bnb-chain`,
  "category/polygon": `${REDIRECT_LINK}/polygon`,
  "category/sd": `${REDIRECT_LINK}/sd-token`,
  "category/hedera": `${REDIRECT_LINK}/hedera`,
  "sd/introduction": `${REDIRECT_LINK}/sd-token`,
  "polygon/stader-dapp/": `${REDIRECT_LINK}/polygon`,
  "Ethereum/Node-operator": `${REDIRECT_LINK}/ethereum/node-operator`,
  "Ethereum/Node-operator/permissioned-node-operator/latest-update": `${REDIRECT_LINK}/ethereum/node-operator`,
  "Ethereum/oracles": `${REDIRECT_LINK}/ethereum/oracles`,
  "sd/bridging-tokens": `${REDIRECT_LINK}/sd-token`,
  "Auditors/blocksec": REDIRECT_LINK,
  "Auditors/osec": REDIRECT_LINK,
  "Auditors/immunebytes": REDIRECT_LINK,
  "Auditors/halborn": REDIRECT_LINK,
  "Auditors/pechshield": REDIRECT_LINK,
  intro: REDIRECT_LINK,
  "polygon/stader-for-polygon": `${REDIRECT_LINK}/polygon`,
  "polygon/intro": `${REDIRECT_LINK}/polygon`,
  "polygon/stader-dapp": `${REDIRECT_LINK}/polygon`,
  "polygon/maticx": `${REDIRECT_LINK}/polygon`,
  "polygon/staking/contract-address": `${REDIRECT_LINK}/polygon`,
  "polygon/staking/intro": `${REDIRECT_LINK}/polygon`,
  "polygon/staking/staking-on-polygon-mainnet": `${REDIRECT_LINK}/polygon`,
  "polygon/staking/staking-on-ethereum-mainnet": `${REDIRECT_LINK}/polygon`,
  "polygon/bridging/bridge-maticx-from-polygon-to-ethereum": `${REDIRECT_LINK}/polygon`,
  "polygon/bridging/add-maticx-to-your-tokens-list": `${REDIRECT_LINK}/polygon`,
  "polygon/bridging/bridge-maticx-from-ethereum-to-polygon": `${REDIRECT_LINK}/polygon`,
  "polygon/bridging/intro": `${REDIRECT_LINK}/polygon`,
  "polygon/fees": `${REDIRECT_LINK}/polygon`,
  "polygon/rewards-and-earnings": `${REDIRECT_LINK}/polygon`,
  "polygon/wallets": `${REDIRECT_LINK}/polygon`,
  "polygon/security": `${REDIRECT_LINK}/polygon`,
  "hedera/v3": `${REDIRECT_LINK}/hedera`,
  "hedera/rewards-earnings": `${REDIRECT_LINK}/hedera`,
  "hedera/HBARX": `${REDIRECT_LINK}/hedera`,
  "hedera/staking-1": `${REDIRECT_LINK}/hedera`,
  "hedera/stader-for-hedera": `${REDIRECT_LINK}/hedera`,
  "hedera/Withdraw": `${REDIRECT_LINK}/hedera`,
  "hedera/Staking": `${REDIRECT_LINK}/hedera`,
  "hedera/Fees": `${REDIRECT_LINK}/hedera`,
  "hedera/Unstaking": `${REDIRECT_LINK}/hedera`,
  "hedera/wallets": `${REDIRECT_LINK}/hedera`,
  "hedera/Security": `${REDIRECT_LINK}/hedera`,
  "SD Utility Pool/asset-security-and-risks": `${REDIRECT_LINK}/sd-token`,
  "SD Utility Pool/health-factor-and-liquidation": `${REDIRECT_LINK}/sd-token`,
  "SD Utility Pool/README": `${REDIRECT_LINK}/sd-token`,
  "SD Utility Pool/sd-utilization/how-to-utilize-sd": `${REDIRECT_LINK}/sd-token`,
  "SD Utility Pool/sd-utilization/README": `${REDIRECT_LINK}/sd-token`,
  "SD Utility Pool/sd-utilization/sd-repayment": `${REDIRECT_LINK}/sd-token`,
  "SD Utility Pool/Disclaimer": `${REDIRECT_LINK}/sd-token`,
  "SD Utility Pool/SD Delegation/sd-delegation": `${REDIRECT_LINK}/sd-token`,
  "SD Utility Pool/SD Delegation/README": `${REDIRECT_LINK}/sd-token`,
  "SD Utility Pool/SD Delegation/claim-sd": `${REDIRECT_LINK}/sd-token`,
  "SD Utility Pool/SD Delegation/withdraw-sd": `${REDIRECT_LINK}/sd-token`,
  "binance/staking": `${REDIRECT_LINK}/bnb-chain`,
};

const RedirectPage: React.FC<{ redirectUrl: string }> = ({ redirectUrl }) => {
  const [countdown, setCountdown] = useState(5);
  const router = useRouter();

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          router.push(redirectUrl);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [redirectUrl, router]);

  return (
    <div id="container" style={styles.container}>
      <main style={styles.main}>
        <section id="hero" style={styles.hero}>
          <a href="https://www.staderlabs.com">
            <div style={styles.logo}>
              <img
                src="/assets/images/stader-icon.svg"
                width="40"
                height="40"
                alt="Staderlabs Homepage"
              />
              <h2>Stader Labs</h2>
            </div>
          </a>
          <h1 style={styles.h1}>
            We&apos;ve moved our documentation to GitBook!
          </h1>
          <p style={styles.p}>
            Redirecting in <span id="countdown">{countdown}</span> seconds.. If
            you&apos;re not redirected automatically,{" "}
            <a href={redirectUrl}>click here</a>.
          </p>
        </section>
      </main>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    overflow: "hidden",
    backgroundImage: `url(/assets/images/docs-bg.svg)`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  background: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: -1,
    filter: "blur(100px)",
  },
  logo: {
    display: "flex",
    alignItems: "center",
    fontSize: "24px",
    fontWeight: "bold",
  },
  main: {
    height: "100dvh",
    display: "flex",
    justifyContent: "center",
    background: "transparent",
  },
  hero: {
    display: "flex",
    alignItems: "start",
    flexDirection: "column",
    justifyContent: "center",
    padding: "16px",
  },
  h1: {
    fontSize: "22px",
    marginTop: "0.25em",
    marginBottom: "0.25em",
  },
  p: {
    marginTop: "0.25em",
    marginBottom: "0.25em",
  },
};

export const getStaticPaths: GetStaticPaths = () => {
  return {
    paths: Object.keys(REDIRECT_MAP).map((slug) => ({
      params: { slug: slug === "" ? [] : slug.split("/") },
    })),
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const slug = params?.slug ?? [];
  const slugArray = Array.isArray(slug) ? slug : [slug];
  const slugKey = slugArray.join("/");

  const redirectUrl = REDIRECT_MAP[slugKey] ?? REDIRECT_LINK;

  return {
    props: {
      redirectUrl,
    },
  };
};

export default RedirectPage;
